import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { MatLegacyDialog as MatDialog } from "@angular/material/legacy-dialog";
import { ConfigurationService, EventsService } from "@app/_shared";
import { PaymentConfirmationComponent } from "@app/_shared/modules/payment-confirmation/payment-confirmation.component";
import { PaymentGateway, PaymentMode } from "./plans.enums";
import { PaymentHandler } from "./plans.service";
import { CustomEvents } from '@app/_helpers';

declare var Chargebee: any;

@Injectable({
    providedIn: 'root'
})
export class ChargeBeeHandler extends PaymentHandler {

    constructor(
        private http: HttpClient,
        private conf: ConfigurationService,
        private dialog: MatDialog,
        public eventService: EventsService,
    ) {
        super();
    }

    onInit(): void {
        this.conf.getServerConfig().subscribe(res => {
            const site = res.chargebee_key;
            var cbInstance = Chargebee.init({
                site: site
            })
        })
    }

    openCheckout(id: number, paymentMode: PaymentMode, paymentGateway: PaymentGateway, isAutoPayOff: boolean) {
        const _this = this;
        let cbInstance = Chargebee.getInstance();
        cbInstance.openCheckout({
            hostedPage: () => {
                return this.getPlanPaymentPromise(id, paymentMode, paymentGateway, isAutoPayOff);
            },
            loaded: function () {
                console.log("checkout opened");
            },
            close: () => {
                console.log("checkout closed");
                // this.openSuccessDialog();
            },
            success: function (hostedPageId) {
                console.log('successfull attempt ', hostedPageId);
                cbInstance.closeAll();
                _this.eventService.publish(CustomEvents.PaymentResult);
            },
            step: function (value) {
                // value -> which step in checkout
                console.log(value);
            }
        });
    }

    submitPayment(id, upi, paymentMode, paymentGateway, isAutoPayOff, discountCoupon = '') {
        const url = this.conf.applicationUrls.upgradePlan;
        return this.http.put(url, {
            id: id,
            upi: upi,
            payment_mode: paymentMode,
            payment_gateway: paymentGateway,
            is_auto_pay_off: isAutoPayOff,
            coupon_ids: (discountCoupon)? [discountCoupon]: []
        })
    }

    openSuccessDialog() {
        this.dialog.open(PaymentConfirmationComponent, {
            height: '400px',
            width: '400px',
            panelClass: ['dialog-no-padding', 'floating-button'],
        });
    }

    verifyVPA(upi: string) {
        const url = this.conf.applicationUrls.verifyVPA + upi;
        return this.http.get(url);
    }

    getPlanPaymentPromise(id: number, paymentMode: PaymentMode, paymentGateway: PaymentGateway, isAutoPayOff: boolean) {
        const url = this.conf.applicationUrls.upgradePlan;

        return new Promise((resolve, reject) => {
            this.http.put(url, {
                id: id,
                upi: '',
                payment_mode: paymentMode,
                payment_gateway: paymentGateway,
                is_auto_pay_off: isAutoPayOff
            }).subscribe({
                next: (res: any) => {
                    resolve(res['result']['hosted_page']);
                },
                error: (err: any) => {
                    reject(err);
                },
                complete: () => {
                    console.log('complete');
                },
            })
        })
    }
}
